import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Devicepersian_Interface } from 'src/app/Interface/Devicepersian_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DevicepersianService {

  constructor(private http:HttpClient) { }


  GetRecord(
    StartSearchDate:string,
    EndSearchDate:string,
    DeviceTitle:string,
    Token:String):Observable<Array<Devicepersian_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Devicepersian?token="+Token
    + "&StartSearchDate="+StartSearchDate
    + "&EndSearchDate="+EndSearchDate
    + "&DeviceTitle="+DeviceTitle
    ).pipe(
      map(data=>{
        return data as Array<Devicepersian_Interface>
      })
    )
  }

  GetDevicePersian(Token:String,id:number):Observable<Array<Devicepersian_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Devicepersian/GetDevicePersian?token="+Token+"&id="+id).pipe(
      map(data=>{
        return data as Array<Devicepersian_Interface>
      })
    )
  }

  GetDevicePersianEngHelp(Token:String,key:String):Observable<Array<any>>{
    return this.http.get(environment.BaseUrl + "Daro/Devicepersian/GetDevicePersianEngHelp?token="+Token+"&key="+key).pipe(
      map(data=>{
        return data as Array<any>
      })
    )
  }

  GetSingle(Token:String,id:Number):Observable<Devicepersian_Interface>{
    return this.http.get(environment.BaseUrl + "Daro/Devicepersian/GetSingle?token="+Token+"&id="+id).pipe(
      map(data=>{
        return data as Devicepersian_Interface
      })
    )
  }

  AddDevicepersian(model: Devicepersian_Interface,Token:String):Observable<Devicepersian_Interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      id:model.id,
      device_id:model.device_id,
      dsc:model.dsc,
      del:false,
      username:Token
    }


      return this.http.post(environment.BaseUrl + "Daro/Devicepersian/Add",body,{headers}).pipe(
        map(data=>{
          return data as Devicepersian_Interface
        })
      )

  }

  EditDevicepersian(model: Devicepersian_Interface,Token:String):Observable<Devicepersian_Interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      id:model.id,
      dsc:model.dsc,
      del:false,
      username:Token
    }


      return this.http.post(environment.BaseUrl + "Daro/Devicepersian/Edit",body,{headers}).pipe(
        map(data=>{
          return data as Devicepersian_Interface
        })
      )

  }

  DeleteDevicepersian(id:number,Token:String):Observable<Devicepersian_Interface>{

      return this.http.get(environment.BaseUrl + "Daro/Devicepersian/Delete?id="+id+"&token="+Token).pipe(
        map(data=>{
          return data as Devicepersian_Interface
        })
      )

  }

  }
